import { SectionsProvider as Root } from './SectionsProvider'
import { AutoFillFieldsSection } from './AutoFillFieldsSection'
import { ManualFieldsSectionContainer as ManualFieldsSection } from './ManualFieldsSection'

export const Sections = {
  Root,
  ManualFieldsSection,
  AutoFillFieldsSection,
}
